const defaultAccessCheck = (projectId = null) => {
    const isCompanyManager      = [gd.const.company.role.MANAGER].includes(gd.company.role);
    const isProjectFullAccess   = !!projectId && gd.ac.check.project.fullAccess(projectId);

    // const isCompanyManager      = false;
    // const isProjectFullAccess   = !!projectId;

    return isCompanyManager || isProjectFullAccess
}

export default class AccessControl_Automations {

    constructor() {
    }

    view(projectId)     {return defaultAccessCheck(projectId)}
    create(projectId)   {return defaultAccessCheck(projectId)}
    edit(projectId)     {return defaultAccessCheck(projectId)}

    createGlobal()      {return [gd.const.company.role.MANAGER].includes(gd.company.role)}

    static checkLicense() {
        // at least PRO
        if (!gd.company.license.isPro) return false
        return true
    }

    static checkAccess() {
        // at least company Manager

        if (!gd.user.isManager()) return false

        return true
    }

    enabled() {

        return true

        // gd.session.companies.get(gd.companyId).license.isPro)

        // return false
    }

}

